module.exports = __webpack_public_path__ + "static/bg-planning-7ec3e67d05a86a06f775007e84c52c61.svg";